import { __assign, __rest } from "tslib";
import React from 'react';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import PremiumIcon from '@wix/da-ds/pkg/Icons/Premium';
import ActionBarButton from '../../_partials/items/ActionBarButton';
var DownloadButtonInner = function (_a) {
    var downloadUrl = _a.downloadUrl, dataHook = _a.dataHook, tooltip = _a.tooltip, deviationId = _a.deviationId, isPaidDownload = _a.isPaidDownload, isHighlighted = _a.isHighlighted, showPremiumIcon = _a.showPremiumIcon, actionBarButtonProps = __rest(_a, ["downloadUrl", "dataHook", "tooltip", "deviationId", "isPaidDownload", "isHighlighted", "showPremiumIcon"]);
    return (React.createElement(ActionBarButton, __assign({}, (downloadUrl && {
        href: downloadUrl,
        target: '_blank',
        download: true,
    }), { biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            ispaiddownload: isPaidDownload ? 1 : 0,
            deviationid: deviationId,
        } }, actionBarButtonProps),
        React.createElement(ActionBarIcon, { isActive: isHighlighted, icon: showPremiumIcon ? PremiumIcon : DownloadIcon })));
};
DownloadButtonInner.displayName = 'DownloadButtonInner';
export default DownloadButtonInner;
//# sourceMappingURL=DownloadButtonInner.js.map